export const USDC_CONTRACT = '0x3c499c542cEF5E3811e1192ce70d8cC03d5c3359';
export const USDC_DECIMALS = 6;
export const TRANSFER_EVENT_TOPIC =
  '0xddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef';
export const POLYGON_CHAIN_ID = 137;
export const POLYGONSCAN_BASE_URL = 'https://polygonscan.com';
